export default __webpack_public_path__ + "static/media/pixel5-bg-dark.6eeff009.webp";